/**
 * Generates a random alpha-numeric string for ids etc.
 *
 * @param {number} length of string
 * @return {string}
 */
export const randomIdentifierGenerator = (length = 6): string => {
    const dec = 2
    const radix = 36
    const max = 11
    let id = ''
    while (id.length < length) {
        id += Math.random().toString(radix).slice(dec).slice(-Math.min(max, length))
    }
    return id
}
